export default "__VITE_ASSET__XwJmavgQXzaqCbIGfrvZBw__"